import React from 'react';
import { Route } from 'react-router';
import { Switch, withRouter, BrowserRouter } from 'react-router-dom';
import { save, get_user_info_ajax } from "../store/action";
import { connect } from 'react-redux';

import Config from '@/config/config';
import { axiosConfig } from '../utils/axiosConfig';
import cookie from 'react-cookies';
import PrivateRoute from './PrivateRoute';// 鉴权使用

import LoadingIcon from '../static/loading.png';

// 页面
import HomePage from '../pages/home' // 首页
import VideoPage from '../pages/video' // 视频

const Routes = withRouter(({ location }) => (
  <Switch location={location}>
    <Route exact path="/" component={HomePage} />
    <Route exact path="/video" component={VideoPage} />
    {/*
      判断当前页面是否必须有token才可以进入的使用方法
      <PrivateRoute exact path="/count_down" component={CountDownPage} />
    */}
  </Switch>
));

class App extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showPage: false,
    }
  };

  componentDidMount() {
    const that = this;
    const { get_user_info_ajax } = that.props;
    const token = cookie.load('token') || '';

    axiosConfig().then(() => {
      if (token) {
        // 获取用户信息（必须有token后才可以获取）
        get_user_info_ajax(() => {
          that.setState({
            showPage: true,
          })
        });
      } else {
        that.setState({
          showPage: true,
        });
      };
    });
  }

  render() {
    const { showPage } = this.state;

    return (
      <div>
        {showPage ?
          <BrowserRouter basename={Config.basename}>
            <Routes />
          </BrowserRouter>
          : <img className="loading_animation" style={{ width: '128px', height: "128px", position: 'fixed', left: '50%', top: '50%', margin: '-64px 0 0 -64px' }} src={LoadingIcon} alt="LoadingIcon" />
        }
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {}
};
const mapDispatchToProps = (dispatch) => {
  return {
    get_user_info_ajax(fn) {
      dispatch(get_user_info_ajax(fn));
    },
    save(data) {
      dispatch(save(data));
    }
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
